














import identitySettings from "../identitySettings/index.vue";
import storeStaff from "../storeStaff/index.vue";
import { PageModule } from "@/store/module/page";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "storeIndex",
  components: { identitySettings, storeStaff },
})
export default class extends Vue {
  activeName = "storeStaff";
  types = "";
  created() {
    const _t = this as any;
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      _t.activeName = this.$route.params.tab || "storeStaff";
    } else {
      if (_t.$route.query.type) {
        _t.activeName = "identitySettings";
        _t.types = _t.$route.query.type;
      }
    }
  }
}
